export default "__VITE_ASSET__LVdgSM_ociFhP5jlDaPsnQ__"